import React, { useState, useEffect, useContext, useMemo } from "react";
import URLstateContext from "../../../../provider/CommonContext";
import { Col, Container, Row } from 'react-bootstrap';
import './CostOfCarry.css';
import Pagination from '../../../CommonUI/Pagination/Pagination';
import MarketFandO from "../../MarketFandO";
import { Vortex } from 'react-loader-spinner'



function CostOfCarry() {
    const [data, setData] = useState([]);

    const [dataGroup, setDataGroup] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const { BaseURL } = useContext(URLstateContext);

    const [loadingshow, setloadingshow] = useState(false);

    let getData, getDataGroup, eleBtn, eleBtnLoose, eleLi;
    let PageSize = 8;


    useEffect(() => {
        setloadingshow(true);

        const getUrl = BaseURL + "CostOfCarry";


        fetch(`${getUrl}/C/-`)
            .then((response) => response.json())
            .then((data) => {
                getData = data.data;
                setData(getData);
                setloadingshow(false);
                // console.log(getData, "getData")
            })
            .catch((error) => {
            });


    }, []);



    const currentTableData = useMemo(() => {
        if (data != null && data != []) {
            const firstPageIndex = (currentPage - 1) * PageSize;
            const lastPageIndex = firstPageIndex + PageSize;
            if (data != null && data != []) {
                if (data.length > 0) {
                    return data.slice(firstPageIndex, lastPageIndex);
                }
            }
        }
    }, [currentPage, data]);


    return (
        <>
            <div class="col-12 p-0 breadcrumMF ">
                <ul>
                    <li><a href="/">Home</a> <i class="fa fa-angle-right" aria-hidden="true"></i></li>
                    <li><a href="/market/futures-and-options">F & O</a> <i class="fa fa-angle-right" aria-hidden="true"></i></li>
                    <li>Cost Of Carry</li>
                </ul>
            </div>
            <Container>
                <Row>
                    <Col sm={12}>
                        <section className='CostCa-loser-sc'>
                            <div className='CostCa-header'>
                                <h2><span>Cost Of Carry</span></h2>
                            </div>
                            <MarketFandO optionValue="Cost of Carry" optionDrop="Derivative" />
                            {/* <hr className="Mosthr"></hr> */}
                            <div className='CostCa-table table-responsive'>
                                <table className='table'>
                                    <thead>
                                        <tr>
                                            <th className='text-left' >Symbol</th>
                                            <th className='text-right'>Market Price(&#8377;)</th>
                                            <th className='text-right'>Future Price (&#8377;)</th>
                                            <th className='text-right'>Expiry Date</th>
                                            <th className='text-right'>Cost Of Carry</th>
                                            <th className='text-right'>Open Interest</th>
                                            <th className='text-right'>Change In OI (%)</th>

                                        </tr>

                                    </thead>
                                    <tbody>
                                        {currentTableData && currentTableData.map(

                                            ({ SYMBOL, ltp, CLOSEPRICE, expdate, COC, openinterest, chg }) => (
                                                <tr>

                                                    <td className="text-left"> {SYMBOL}</td>

                                                    <td className="text-right"> {(ltp != null) ? ltp.toFixed(2) : 0}</td>
                                                    <td className="text-right"> {(CLOSEPRICE != null) ? CLOSEPRICE.toFixed(2) : 0}</td>
                                                    <td className="text-right">{expdate}</td>
                                                    <td className="text-right"> {(COC != null) ? COC.toFixed(2) : 0}</td>
                                                    <td className="text-right"> {(openinterest != null) ? openinterest.toFixed(2) : 0}</td>
                                                    <td className="text-right"> {(chg != null) ? chg.toFixed(2) : 0}</td>

                                                </tr>
                                            ))}
                                    </tbody>
                                </table>
                                {loadingshow ? <div className="textcentervertex">
                                                        <Vortex
                                                            visible={true}
                                                            height="80"
                                                            width="80"
                                                            ariaLabel="vortex-loading"
                                                            wrapperStyle={{}}
                                                            wrapperClass="vortex-wrapper"
                                                            colors={['#0473ea', '#0473ea', '#0473ea', '#39d800', '#39d800', '#39d800']}
                                                        />
                                                        <div className="model_popup">Please Wait...</div>
                                                    </div> : ""
                                                    }
                            </div>
                            {(data != null && data != []) ?
                                <Pagination
                                    className="pagination-bar_peer"
                                    currentPage={currentPage}
                                    totalCount={(data.length != null) ? data.length : 0}
                                    pageSize={PageSize}
                                    onPageChange={page => setCurrentPage(page)}
                                /> : <p className="errorPeer"> No Data Found !!! </p>}

                        </section>
                    </Col>
                </Row>
            </Container>
        </>
    );
}

export default CostOfCarry;